module.exports = __webpack_public_path__ + "static/media/Hbook-14.9b69cef6.jpg";